<template>
    <f7-page id="reset-password-email" name="reset-password-email" @page:beforein="init()" @page:afterin="afterin">
        <f7-navbar class="view-mobile">
            <f7-nav-left class="back-button">
                <f7-link icon-f7="chevron_left" @click="backButton" color="black"></f7-link>
            </f7-nav-left>
            <f7-nav-right></f7-nav-right>
        </f7-navbar>
        <div class="block">
            <div class="b fs-24 mb-md">{{$t('account-reset-password')}}</div>
            <div class="fs-14 fw-medium mb-xxl text-color-gray">
                {{$t('account-reset-password-email')}}
            </div>


            <transition name="fade">
              <f7-card
                  :title  ="alertCard.title"
                  class   ="alert alert-danger"
                  v-show  ="alertCard.show"
              >
                  <i class="icon f7-icons card-close" @click="alertCard.show=false">xmark</i>
              </f7-card>
            </transition>
            <f7-list class="form-group" style="">

              <f7-list-input
                input-id      ="email"
                name          ="email"
                type          ="email"
                class         =""
                placeholder   =""
                @input        ="email = $event.target.value;validateInput($event.target);validateNextButton();"
                :label        ="$t('general-text-email')"
                autocomplete  ="off"
                outline
                floating-label
                required
                clear-button
              >

              </f7-list-input>
            </f7-list>

            <f7-button @click="goToNextPage" large fill :disabled="!isNextButtonValid" class="view-desktop">{{$t('general-btn-submit')}}</f7-button>
        </div>

        <f7-toolbar position="bottom" no-hairline class="toolbar-with-button view-mobile">
            <f7-button large fill @click="goToNextPage" :disabled="!isNextButtonValid">
                {{$t('general-btn-submit')}}
            </f7-button>
        </f7-toolbar>
    </f7-page>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import { check } from '@/plugins/helper';
    export default {
        mounted (){

        },
        data() {
            return {
                isNextButtonValid   : false,
                isEmailValid        : false,
                email               : "",
                alertCard: {
                    show   : false,
                    title  : "",
                    content: ""
                },
            }
        },
        methods: {
            ...mapActions('customer', []),
            ...mapActions('auth', ['logout']),

            afterin(){
                window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
            },

            async init(){
                const pid = this.$f7route.query['pid']; // check page ID
                //console.log("page ID : " + pid);

                if(pid == "login"){
                    await this.logout();
                }
            },

            validateInput(e) {
                var inputName   = e.name;
                var keyName     = "regis-"+e.name;
                var translation;

                var validate = false;
                if (inputName == "email"){
                    validate   = check.validPattern("email", e.value);
                }

                if(!validate){
                    translation = keyName + "-rule";
                    this.setInputState(inputName, this.$t(translation));
                    if(inputName == "email"){
                      this.isEmailValid = false;
                    }
                    this.isNextButtonValid = false;
                    return false;
                }

                if(inputName == "email"){
                    this.isEmailValid = true;
                }

                this.setInputState(inputName, true);
                return true;
              },
              validateNextButton(){
                this.isNextButtonValid = this.isEmailValid;
            },

            async goToNextPage(){
                if (this.email != '' && this.isEmailValid) {
                    this.showPreloader();

                    // CHECK EMAIL VALIDITY
                    var isFormValid = this.isEmailValid

                    if(isFormValid){
                        const reqForgotPassword = await this.$api.customer.forgotPassword(this.email);
                        console.log("reqForgotPassword: ", reqForgotPassword)

                        if(reqForgotPassword.status == "WN00133"){ // request success
                            console.log("reqForgotPassword success")
                            this.$f7router.navigate("/reset-password-verify-email");
                            this.hidePreloader();
                        }else if(reqForgotPassword.status == "0107"){ // max attempt
                            this.showAlert(true, this.$t('reset-password-max-attempt', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
                            this.isNextButtonValid = false;
                            this.hidePreloader();
                        }else if(reqForgotPassword.status == "0305"){ // cust not found
                            this.showAlert(true, this.$t('reset-password-email-not-found'));
                            this.isNextButtonValid = false;
                            this.hidePreloader();
                        }else if(reqForgotPassword.status == "WN00134"){ // invalid error
                            this.showAlert(true, this.$t('reset-password-invalid-error', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
                            this.isNextButtonValid = false;
                            this.hidePreloader();
                        }else if(reqForgotPassword.status == "WN00129"){ // email inactive
                            this.showAlert(true, this.$t('reset-password-email-inactive'));
                            this.isNextButtonValid = false;
                            this.hidePreloader();
                        }else{
                            this.showAlert(true, this.$t('beneficiary-ws-general-error'));
                            this.isNextButtonValid = false;
                            this.hidePreloader();
                        }
                    } else {
                        this.showAlert(true, this.$t('regis-email-invalid'));
                        this.isEmailValid = false;
                        this.hidePreloader();
                        this.validateNextButton();
                    }
                }
            },

            showAlert(status, title, content){
                this.alertCard.show = status;
                if (title == undefined){
                  title = "";
                }
                if (content == undefined){
                  content = "";
                }
                this.alertCard.title= title;
                this.alertCard.content = content;

            },

            backButton() {
                this.$f7router.back({ transition: 'f7-push' });
            }
        },
        computed: {
            ...mapGetters('auth', [
                'authenticating',
                'authenticationError',
                'authenticationErrorCode',
                'authenticationSuccess'
            ]),

            ...mapGetters('customer', [
                'customerName',
            ])
        }
    }
</script>